
const state = {

    isAdmin: false,
    publisherCompanyName: "",
    publisherEmail: ""
}

const getters = {

    isAdmin(state) {
        return state.isAdmin;
    },
    getPublisherEmail(state) {
        return state.publisherEmail;
    },
    getPublisherCompanyName(state) {
        return state.publisherCompanyName;
    }

}

const mutations = {

    setIsAdmin(state, payload) {
        state.isAdmin = payload;
    },
    setPublisherEmail(state, payload) {
        state.publisherEmail = payload;
    },
    setPublisherCompanyName(state, payload) {
        state.publisherCompanyName = payload;
    }

}

const actions = {

}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/admin.js